import { Icon, type IconProps } from './Icon';

export function MapPin(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z" />
      <circle cx="12" cy="10" r="2.5" />
    </Icon>
  );
}
